<template>
  <v-data-table :headers="computedHeader" :items="sortedData" class="elevation-1 table" hide-actions>
    <template v-slot:headers="props">
      <tr>
        <th v-for="header in props.headers" :key="header.text" @click="changeSort(header.value)" :class="[
          'column sortable',
          pagination.descending ? 'desc' : 'asc',
          header.value == 'Equipment' && pagination.sortBy == 'id' ? 'active' : (header.value == pagination.sortBy ? 'active' : ''),
        ]">
          {{ header.text }}
          <v-icon small
            v-show="header.value === pagination.sortBy || header.value == 'Equipment' && pagination.sortBy == 'id'">
            {{ pagination.descending ? 'arrow_downward' : 'arrow_upward' }}
          </v-icon>
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <tr>
        <td>
          <v-checkbox v-model="inverterState[simpleString(props.item.Equipment)]" primary hide-details>
          </v-checkbox>
        </td>
        <td v-for="(items, key, index) in props.item" :key="index" v-show="index >= 1" :class="index == 1
          ? 'text-xs-center'
          : dataCondition(props.item.id, index, items) == 'No Data' ||
            dataCondition(props.item.id, index, items) == 'NC'
            ? 'error--text text-xs-center'
            : 'number--text text-xs-center'
          ">
          {{ dataCondition(props.item.id, index, items) }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { mapGetters, mapMutations } from "vuex";
import service from "@/services/Scb.js";
import service1 from "@/services/zone-monitoring.js";
import { mixin, mapGettersMixin, miscellaneous } from "@/util/mixin/index.js";

export default {
  mixins: [mixin, mapGettersMixin, miscellaneous],
  props: ["dataView", "date", "chips"],
  data: () => ({
    headers: [],
    data: [],
    ncdata: {},
    localChips: [],
    channels: [],
    inverterState: {},
    channelWithId: {},
    enableInverterStateWatch: false,
    pagination: {
      sortBy: "id",
      descending: false,
      page: 1,
      rowsPerPage: 500,
    },
  }),

  computed: {
    sortedData() {
      return this.arraySortHandler(this.data, this.pagination.sortBy === "Equipment" || this.pagination.sortBy === "id" ? "id" : this.pagination.sortBy, this.pagination.descending ? "desc" : "asc")
    },
    ...mapGetters(["getSelectedPlantId"]),
    dateAndDataView() {
      return `${this.date} ${this.dataView}`;
    },
    computedHeader() {
      const resultHeader = [
        {
          text: "",
          value: "",
          sortable: false,
        },
      ];
      this.headers.forEach((el) => {
        const obj = _.cloneDeep(el);
        obj["align"] = "center";
        if (!el.text.includes("Ch")) {
          obj["text"] = this.$t(el.text);
        }
        resultHeader.push(obj);
      });
      return resultHeader;
    },
  },
  async created() {
    await this.setIntervalWithoutDelay(this.callAllApi);
  },
  methods: {
    ...mapMutations(["SET_PROGRESS_BAR", "SET_LAST_CALL_TIME"]),
    changeSort(column) {
      if (column) {
        if (this.pagination.sortBy === column) {

          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      }
    },
    async callAllApi() {
      let updateTime = moment().format("MM-DD-YYYY H:mm:ss");
      this.SET_LAST_CALL_TIME(updateTime);
      await this.getTableData();
    },
    dataCondition(id, index, items) {
      if (this.ncdata[id] && this.ncdata[id].indexOf(`${index - 4}`) !== -1) {
        return "NC";
      } else if (index > 1) {
        if (items == null) {
          return "No Data";
        } else {
          return parseFloat(items).toFixed(2);
        }
      }
      return items;
    },
    async getTableData() {
      try {
        this.SET_PROGRESS_BAR(true);
        let response = await service.getStingInverterData({
          plantId: this.getSelectedPlantId,
          index: this.dataView,
          date: this.date,
        });
        let count = await service1.getStringCount(this.getSelectedPlantId);
        this.SET_PROGRESS_BAR(false);
        this.data = response.data.message.data;

        this.data.forEach((el) => {
          let key = this.simpleString(el.Equipment);
          this.$set(this.inverterState, key, false);
        });
        this.enableInverterStateWatch = true;
        this.ncdata = count.data.message;
        this.headers = response.data.message.headers;
      } catch (err) {
        this.SET_PROGRESS_BAR(false);
      }
    },
    inverterSelected(key) {
      key = this.simpleString(key);
      this.channels = [];
      const originalObject = {};
      originalObject[key] = this.data.filter(
        (d) => this.simpleString(d.Equipment) == key
      )[0];

      const { id } = originalObject[key];
      let range = Object.keys(originalObject[key]).length - 5;

      if (this.inverterState[key]) {
        for (let i = 0; i < range; i++) {
          this.channels.push(i + 1);
        }
        if (this.ncdata[id] !== undefined) {
          Object.entries(this.ncdata[id]).forEach(([key, value]) => {
            if (this.channels.includes(value) === false) {
              let key = this.channels.indexOf(parseInt(value));
              this.channels.splice(key, 1);
            }
          });
        }

        this.channels
          .filter((val) => !this.localChips.includes(id.concat("-ch-", val)))
          .forEach((el) => {
            this.localChips.push(id.concat("-ch-", el));
          });

        this.channelWithId[id] = this.channels;
      } else {
        for (let i = 1; i <= range; i++) {
          let localKey = this.localChips.indexOf(id.concat("-ch-", i));
          this.channels.push(i);
          if (localKey > -1) {
            this.localChips.splice(localKey, 1);
            this.localChips = [...this.localChips];
          }
        }
        delete this.channelWithId[id];
      }
    },
  },
  watch: {
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi);
      }
    },
    data() {
      this.data.forEach((item) => {
        if (this.enableInverterStateWatch) {
          this.$watch(
            "inverterState." + this.simpleString(item.Equipment),
            function () {
              this.inverterSelected(item.Equipment);
            }
          );
        }
      });
    },
    dateAndDataView() {
      this.getTableData();
    },
    localChips() {
      this.$emit("chipsUpdate", {
        chips: this.localChips,
        chipsObj: this.channelWithId,
      });
    },
    chips() {
      const removeLast2String = (arr) => {
        let chip = arr.map((el) => {
          return el.split("-ch-")[0];
        });
        const uniqueChip = [...new Set(chip)];
        return uniqueChip;
      };

      const currentChip = removeLast2String(this.chips);
      const oldChip = removeLast2String(this.localChips);
      if (!this.isArrEqual(currentChip, oldChip)) {
        const unCheckedCheckbox = this.arrDifference(oldChip, currentChip)[0];
        const inverterStateKey = this.data.filter(
          (el) => el.id === unCheckedCheckbox
        )[0];
        this.inverterState[
          this.simpleString(inverterStateKey.Equipment)
        ] = false;
      }
    },
  },
};
</script>

<style scoped>
.table {
  height: calc(100vh - 305px);
  overflow-x: auto;
  overflow-y: auto;
  display: flex;
}

.table th {
  z-index: 1;
  position: sticky;
  top: 0;
  color: var(--v-extraGrey) !important;
  background: var(--v-primary-base) !important;
}

.arrow-icon {
  color: var(--v-primary-base);
}
</style>
<style>
.table .v-table__overflow {
  overflow: auto;
}
</style>
